export default __webpack_public_path__ + "static/testimonials6-4958f4ccb6fc6c640e352f245bbb3f3c.jpg";